import { useState } from 'react';
import { motion } from "framer-motion";
import ReactHtmlParser from 'react-html-parser';
import Title from "../components/ui/Title";
import '../styles/pages/world.scss';


const World = () => {

    const [current, setCurrent] = useState(0)

    const changeCurrrent = (number) => {
        setCurrent(number)
    }

    return (
        <div className="page-container">
            <Title text="LOCATIONS" />
            <motion.header className="world-banner" 
                initial={{
                    opacity: 0
                }}
                animate={{
                    opacity: 1
                }}
                transition={{
                    delay: 1
                }}
            >
                <h1>
                    Follow the Special Support Section as their new duties take them to new locales throughout Crossbell State.
                </h1>
            </motion.header>
            <section className="location-list">
                {
                    Data.map((location, index)=>(
                        <motion.div className="button-wrapper"
                            initial={{
                                x: '-50%',
                                opacity: 0
                            }}
                            animate={{
                                x: 0,
                                opacity: 1
                            }}
                            transition={{
                                delay: 1+index*0.25,
                                ease: 'easeOut'
                            }}
                        >
                            <LocationButton location={location} current={index === current}
                                onClick={()=>{changeCurrrent(index)}}
                            />
                        </motion.div>
                    ))
                }
                <div className="marker" id="world"></div>
            </section>
            <motion.article className="location-container"
                style={{backgroundImage: `url(${process.env.PUBLIC_URL}/img/world/${Data[current]["image"]}.webp)`}}
                initial={{
                    opacity: 0
                }}
                animate={{
                    opacity: 1
                }}
                transition={{
                    delay: 2
                }}
            >
                <div className="location-wrapper">
                    <img src={`${process.env.PUBLIC_URL}/img/world/${Data[current]["image"]}.webp`} alt={Data[current]["name"]} />
                    <div className="location-info">
                        <h1>{Data[current]["name"]}</h1>
                        <div className="text-wrapper">
                            {
                                ReactHtmlParser(Data[current].bio)
                            }
                        </div>
                    </div>
                </div>
            </motion.article>
        </div>
    )
}

const LocationButton = ({location, current, ...props}) => (
    <a href="#world">
        <div className={current ? "location-button current" : "location-button"}
            style={{backgroundImage: `url(${process.env.PUBLIC_URL}/img/world/${location.image}.webp)`}}
            {...props}
        >
            <h1>
                {location.name}
            </h1>
        </div>
    </a>
)

const Data = [
    {
        name: "Altair",
        image: "altair",
        bio: "<p>A port city located in the westernmost end of Calvard.</p><p>Situated near the Cyre River, Altair is a thriving hub of distribution and commerce. As it is less than an hour away from Crossbell City by train, merchants often travel between the two in droves.</p>"
    },
    {
        name: "Crossbell Police Academy",
        image: "police",
        bio: "<p>A school for police recruits located in the Knox Forest southwest of Crossbell City.</p><p>In addition to instructing general law enforcement personnel, the academy also provides lessons for handling police vehicles, as well as training for detectives and forensic officers awaiting certification.</p><p>There are also a variety of administrative facilities on the premises, such as a prison and a training area for the Crossbell Guardian Force.</p>"
    },
    {
        name: "Garrelia Fortress",
        image: "fortress",
        bio: "<p>A military installation built into a cliff in eastern Erebonia. It boasts ironclad defenses that have held off Calvardian invasions since time immemorial.</p><p>Military tensions have risen to an all-time high since the introduction of railway guns to the fortress' arsenal. Known for their unprecedented destructive power, their effective range makes them capable of mounting a direct assault on Crossbell City.</p>"
    },
    {
        name: "Orchis Tower",
        image: "orchis",
        bio: "<p>The new City Hall building located in the northern side of Crossbell City.</p><p>At 40 stories tall, it is the first skyscraper in the history of the continent. Built as a hub for Crossbell's administration, it is also intended to serve as a center of international dialogue and trade in western Zemuria.</p><p>Construction was completed and the building unveiled shortly after new mayor Dieter Crois took office.</p>"
    },
    {
        name: "Mishelam Wonderland",
        image: "mishelam",
        bio: "<p>A theme park built on the other end of Lake Elm from Crossbell City. Its many attractions, such as the ferris wheel and the Horror Coaster, make it one of the state's most popular tourist destinations alongside Arc en Ciel.</p><p>In <em>Trails to Azure</em>, the Special Support Section will at last be able to enjoy everything Mishelam Wonderand has to offer!</p>"
    },
]

export default World;